(() => {
  const moneyFormat = (window.Shopify && window.Shopify.money_format) || "${{amount}}";

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(Number(cents || 0), moneyFormat);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  };

  const clampMultiplier = (raw) => {
    const n = Number(String(raw ?? "0").replace(",", ".")) || 0;
    return Math.max(0, Math.min(5, n));
  };

  const fetchCart = async () => {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js fetch failed");
    return res.json();
  };

  const updateLine = (wrap, item) => {
    const msrpEnabled = String(wrap.dataset.msrpEnabled) === "true";
    const multiplier = clampMultiplier(wrap.dataset.msrpMultiplier);

    // UI 정책: 라인에서는 항상 합계 표시
    // current_line = item.final_line_price (쿠폰/할인 반영)
    // msrp_line    = item.original_price(≈variant.price) * multiplier * qty
    const qty = Number(item.quantity || 0);
    const currentLine = Number(item.final_line_price || 0);
    const sellingUnit = Number(item.original_price || 0);

    const currentEl = wrap.querySelector("[data-line-current]");
    if (currentEl) currentEl.textContent = formatMoney(currentLine);

    const msrpWrap = wrap.querySelector("[data-line-msrp-wrap]");
    const msrpEl = wrap.querySelector("[data-line-msrp]");
    const savingEl = wrap.querySelector("[data-line-saving]");

    let msrpLine = 0;
    if (msrpEnabled && multiplier > 1 && sellingUnit > 0 && qty > 0) {
      msrpLine = Math.round(sellingUnit * multiplier) * qty;
    }

    if (msrpWrap && msrpEl) {
      if (msrpLine > 0) {
        msrpEl.textContent = formatMoney(msrpLine);
        msrpWrap.classList.remove("hidden");
      } else {
        msrpWrap.classList.add("hidden");
      }
    }

    if (savingEl) {
      const saving = msrpLine - currentLine;
      if (msrpLine > 0 && saving > 0) {
        savingEl.innerHTML = `You\u2019re saving&nbsp;${formatMoney(saving)} today`;
        savingEl.classList.remove("hidden");
      } else {
        savingEl.classList.add("hidden");
      }
    }
  };

  const syncDrawerLines = async () => {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer) return;

    // 드로워가 실제로 열려있을 때만
    if (drawer.offsetParent === null) return;

    const wraps = drawer.querySelectorAll("[data-cart-line-price][data-key]");
    if (!wraps.length) return;

    const cart = await fetchCart();
    const map = new Map((cart.items || []).map((it) => [it.key, it]));

    wraps.forEach((wrap) => {
      const key = wrap.dataset.key;
      const item = map.get(key);
      if (!item) return;
      updateLine(wrap, item);
    });
  };

  const debounce = (fn, wait = 120) => {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(() => fn().catch(() => {}), wait);
    };
  };

  const initObservers = () => {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer) return;

    const run = debounce(syncDrawerLines, 150);

    // 토탈 영역이 바뀌는 순간(수량 변경/쿠폰/추가 후) = 갱신 완료 신호
    const totalBox = drawer.querySelector(".cart-drawer-price-total");
    if (totalBox) {
      const moTotal = new MutationObserver(run);
      moTotal.observe(totalBox, { childList: true, subtree: true, characterData: true });
    }

    // 드로워 자체 변화(오픈 직후에도 1회 맞추기)
    const moDrawer = new MutationObserver(run);
    moDrawer.observe(drawer, { attributes: true, childList: false, subtree: false });

    // 안전망: qty input change / 버튼 클릭에도 트리거
    document.addEventListener("change", (e) => {
      const el = e.target;
      if (!(el instanceof Element)) return;
      if (el.matches("#CartDrawer .cart-qty")) run();
    });

    document.addEventListener("click", (e) => {
      const btn = e.target instanceof Element ? e.target.closest("#CartDrawer .cart-item__quantity button") : null;
      if (btn) run();
    });

    // 최초 1회
    run();
  };

  document.addEventListener("DOMContentLoaded", initObservers);
})();
